import { createSlice } from '@reduxjs/toolkit'
import {
  fetchBillwiseReport,
  fetchBusinessSummary,
  fetchBusinessSummaryCurrent,
  fetchCounterWiseReport,
  fetchDaywiseReport,
  fetchDuplicateBillReport,
  fetchInventoryReport,
  fetchItemWiseReport,
  fetchOutletSummary,
  fetchUserwiseReport,
  fetchWriteOffReport,
  fetchPaymentwiseReport,
  fetchDownloadReport,
  fetchOutletwiseSummaryForFranchise,
  fetchOutletwiseSummary,
  fetchOutletwiseSummaryForOutlet,
  fetchBillDetails,
  fetchWaiterItemWiseReport,
  fetchWaiterCommissionReport,
  fetchWaiterMonthWiseReport,
  fetchWaiterSalesReport
} from './reportsAction'

interface State {
  loading: boolean
  error?: string | null
  data?: []
}

const fetchBusinessSummaryCurrentInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchBusinessSummaryInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchOutletSummaryInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchBillwiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchBillDetailsInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchDaywiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchItemWiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchInventoryReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchUserwiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchCounterWiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchWriteOffReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

const fetchDuplicateBillReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}
const fetchPaymentwiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}
const fetchDownloadReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

export const fetchBusinessSummaryCurrentSlice = createSlice({
  name: 'reports/fetchBusinessSummaryCurrent',
  initialState: fetchBusinessSummaryCurrentInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBusinessSummaryCurrent.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchBusinessSummaryCurrent.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchBusinessSummaryCurrent.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchBusinessSummarySlice = createSlice({
  name: 'reports/fetchBusinessSummary',
  initialState: fetchBusinessSummaryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBusinessSummary.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchBusinessSummary.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchBusinessSummary.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchOutletSummarySlice = createSlice({
  name: 'reports/fetchOutletSummary',
  initialState: fetchOutletSummaryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOutletSummary.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchOutletSummary.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchOutletSummary.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchOutletwiseSummarySlice = createSlice({
  name: 'reports/fetchOutletwiseSummary',
  initialState: fetchOutletSummaryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOutletwiseSummary.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchOutletwiseSummary.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchOutletwiseSummary.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchOutletSummaryForFranchiseSlice = createSlice({
  name: 'reports/fetchOutletSummary',
  initialState: fetchOutletSummaryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOutletwiseSummaryForFranchise.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(
      fetchOutletwiseSummaryForFranchise.fulfilled,
      (state, action) => {
        state.loading = false
        state.data = action.payload
      }
    )
    builder.addCase(
      fetchOutletwiseSummaryForFranchise.rejected,
      (state, action) => {
        state.loading = false
        state.error = action.error.message
      }
    )
  }
})

// Slice for dashboard
export const fetchOutletSummaryForOutletSlice = createSlice({
  name: 'reports/fetchOutletSummaryForOutlet',
  initialState: fetchOutletSummaryInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchOutletwiseSummaryForOutlet.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(
      fetchOutletwiseSummaryForOutlet.fulfilled,
      (state, action) => {
        state.loading = false
        state.data = action.payload
      }
    )
    builder.addCase(
      fetchOutletwiseSummaryForOutlet.rejected,
      (state, action) => {
        state.loading = false
        state.error = action.error.message
      }
    )
  }
})

export const fetchBillwiseReportSlice = createSlice({
  name: 'reports/fetchBillwiseReport',
  initialState: fetchBillwiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBillwiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchBillwiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchBillwiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchDaywiseReportSlice = createSlice({
  name: 'reports/fetchDaywiseReport',
  initialState: fetchDaywiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDaywiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchDaywiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchDaywiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchItemWiseReportSlice = createSlice({
  name: 'reports/fetchItemWiseReport',
  initialState: fetchItemWiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchItemWiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchItemWiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchItemWiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchInventoryReportSlice = createSlice({
  name: 'reports/fetchInventoryReport',
  initialState: fetchInventoryReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchInventoryReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchInventoryReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchInventoryReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchUserwiseReportSlice = createSlice({
  name: 'reports/fetchUserwiseReport',
  initialState: fetchUserwiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserwiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchUserwiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchUserwiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchCounterWiseReportSlice = createSlice({
  name: 'reports/fetchCounterWiseReport',
  initialState: fetchCounterWiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCounterWiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchCounterWiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchCounterWiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchWriteOffReportSlice = createSlice({
  name: 'reports/fetchWriteOffReport',
  initialState: fetchWriteOffReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWriteOffReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchWriteOffReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchWriteOffReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchDuplicateBillReportSlice = createSlice({
  name: 'reports/fetchDuplicateBillReport',
  initialState: fetchDuplicateBillReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDuplicateBillReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchDuplicateBillReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchDuplicateBillReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchPaymentwiseReportSlice = createSlice({
  name: 'reports/fetchPaymentwiseReport',
  initialState: fetchPaymentwiseReportInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentwiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchPaymentwiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchPaymentwiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const downloadReportsSlice = createSlice({
  name: 'reports/fetchDownloadReport',
  initialState: fetchDownloadReportInitialState,
  reducers: {
    reset: () => fetchDownloadReportInitialState
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDownloadReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchDownloadReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchDownloadReport.rejected, (state: any, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchBillDetailsSlice = createSlice({
  name: 'reports/fetchBillDetails',
  initialState: fetchBillDetailsInitialState,
  reducers: {
    reset: () => fetchBillDetailsInitialState
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBillDetails.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchBillDetails.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchBillDetails.rejected, (state: any, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchBusinessSummaryCurrentReducer =
  fetchBusinessSummaryCurrentSlice.reducer
export const fetchBusinessSummaryReducer = fetchBusinessSummarySlice.reducer
export const fetchOutletSummaryReducer = fetchOutletSummarySlice.reducer
export const fetchBillwiseReportReducer = fetchBillwiseReportSlice.reducer
export const fetchDaywiseReportReducer = fetchDaywiseReportSlice.reducer
export const fetchItemWiseReportReducer = fetchItemWiseReportSlice.reducer
export const fetchInventoryReportReducer = fetchInventoryReportSlice.reducer
export const fetchUserwiseReportReducer = fetchUserwiseReportSlice.reducer
export const fetchCounterWiseReportReducer = fetchCounterWiseReportSlice.reducer
export const fetchWriteOffReportReducer = fetchWriteOffReportSlice.reducer
export const fetchDuplicateBillReportReducer =
  fetchDuplicateBillReportSlice.reducer
export const fetchPaymentwiseReportReducer = fetchPaymentwiseReportSlice.reducer
export const downloadReportsReducer = downloadReportsSlice.reducer
export const fetchOutletwiseSummaryForFranchiseReducer =
  fetchOutletSummaryForFranchiseSlice.reducer
export const fetchOutletwiseSummaryReducer = fetchOutletwiseSummarySlice.reducer
export const fetchOutletSummaryForOutletReducer =
  fetchOutletSummaryForOutletSlice.reducer
export const fetchBillDetailsReducer = fetchBillDetailsSlice.reducer

const fetchWaiterItemWiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}
const fetchWaiterCommissionReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}
const fetchWaiterMonthWiseReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}
const fetchWaiterSalesReportInitialState: State = {
  loading: false,
  error: null,
  data: []
}

export const fetchWaiterItemWiseReportSlice = createSlice({
  name: 'reports/fetchWaiterItemWiseReport',
  initialState: fetchWaiterItemWiseReportInitialState,
  reducers: {
    clearWaiterItemWiseState: (state) => {
      state.loading = false
      state.error = null
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWaiterItemWiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchWaiterItemWiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchWaiterItemWiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchWaiterCommissionReportSlice = createSlice({
  name: 'reports/fetchWaiterCommissionReport',
  initialState: fetchWaiterCommissionReportInitialState,
  reducers: {
    clearWaiterCommissionState: (state) => {
      state.loading = false
      state.error = null
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWaiterCommissionReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchWaiterCommissionReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchWaiterCommissionReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchWaiterMonthWiseReportSlice = createSlice({
  name: 'reports/fetchWaiterMonthWiseReport',
  initialState: fetchWaiterMonthWiseReportInitialState,
  reducers: {
    clearWaiterMonthWiseState: (state) => {
      state.loading = false
      state.error = null
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWaiterMonthWiseReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchWaiterMonthWiseReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchWaiterMonthWiseReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const fetchWaiterSalesReportSlice = createSlice({
  name: 'reports/fetchWaiterSalesReport',
  initialState: fetchWaiterSalesReportInitialState,
  reducers: {
    clearWaiterSalesState: (state) => {
      state.loading = false
      state.error = null
      state.data = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWaiterSalesReport.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchWaiterSalesReport.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    builder.addCase(fetchWaiterSalesReport.rejected, (state, action) => {
      state.loading = false
      state.error = action.error.message
    })
  }
})

export const { clearWaiterItemWiseState } = fetchWaiterItemWiseReportSlice.actions
export const { clearWaiterCommissionState } = fetchWaiterCommissionReportSlice.actions
export const { clearWaiterMonthWiseState } = fetchWaiterMonthWiseReportSlice.actions
export const { clearWaiterSalesState } = fetchWaiterSalesReportSlice.actions

export const fetchWaiterItemWiseReportReducer = fetchWaiterItemWiseReportSlice.reducer
export const fetchWaiterCommissionReportReducer = fetchWaiterCommissionReportSlice.reducer
export const fetchWaiterMonthWiseReportReducer = fetchWaiterMonthWiseReportSlice.reducer
export const fetchWaiterSalesReportReducer = fetchWaiterSalesReportSlice.reducer
